export enum TConsumerPlanRegistrationState {
  Error,
  PaperPlan,
  DynamicPlanWithSameEmail,
  DynamicPlanConflictEmail,
  DynamicPlanConflictPhone,
  DynamicPlanConflictAddress,
}
